module.exports = __webpack_public_path__ + "img/win1.a7069afb.png";